(function () {
  function safeGetSessionValue(key) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : '';
    } catch (error) {
      return '';
    }
  }

  function safeSetSessionValue(key, value) {
    try {
      if (window.sessionStorage && value) {
        window.sessionStorage.setItem(key, value);
      }
    } catch (error) {
      /* Ignore storage failures. */
    }
  }

  function queryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (error) {
      return '';
    }
  }

  function referrerHost() {
    try {
      if (!document.referrer) return '';
      var referrer = new URL(document.referrer);
      return referrer.hostname === window.location.hostname ? '' : referrer.hostname;
    } catch (error) {
      return '';
    }
  }

  function sessionSource() {
    var source = queryParam('utm_source') || safeGetSessionValue('plume_aeo_session_source') || referrerHost() || 'direct';
    safeSetSessionValue('plume_aeo_session_source', source);
    return source;
  }

  function sessionMedium() {
    var medium = queryParam('utm_medium') || safeGetSessionValue('plume_aeo_session_medium');
    if (!medium) medium = referrerHost() ? 'referral' : 'none';
    safeSetSessionValue('plume_aeo_session_medium', medium);
    return medium;
  }

  function closestBridge(element) {
    return element && element.closest ? element.closest('.plume-aeo-product-bridge') : null;
  }

  function buildPayload(link, bridge) {
    return {
      page_path: window.location.pathname || '',
      page_type: bridge.getAttribute('data-page-type') || 'aeo_article',
      module_name: bridge.getAttribute('data-module-name') || 'why_plume_elite',
      module_position: bridge.getAttribute('data-module-position') || 'inline_early',
      cta_text: link.getAttribute('data-cta-text') || (link.textContent || '').trim(),
      destination_url: link.getAttribute('data-destination-url') || link.getAttribute('href') || '',
      product_entity: bridge.getAttribute('data-product-entity') || 'plume_elite_lash_brow_serum',
      competitor_context: bridge.getAttribute('data-competitor-context') || 'none',
      ingredient_context: bridge.getAttribute('data-ingredient-context') || 'prostaglandin_analog',
      session_source: sessionSource(),
      session_medium: sessionMedium()
    };
  }

  function isDevelopmentMode() {
    return window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      (window.Shopify && window.Shopify.designMode);
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-aeo-cta="true"]') : null;
    if (!link) return;

    var bridge = closestBridge(link);
    if (!bridge) return;

    var payload = buildPayload(link, bridge);

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'aeo_cta_click', payload);
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'aeo_cta_click',
        aeo_cta_click: payload
      });
    }

    if (isDevelopmentMode() && window.console && typeof window.console.info === 'function') {
      window.console.info('aeo_cta_click', payload);
    }
  }, false);
})();

